import type { CheckoutConfigurationSubscriptionTermsPlacement } from "@commerce/types/CheckoutConfiguration.types";

export const shouldShowSidebarSubscriptionBillingDisclaimer = (
  subscriptionTermsPlacement: CheckoutConfigurationSubscriptionTermsPlacement | null | undefined,
  isDesktopView: boolean
): boolean => !isDesktopView || subscriptionTermsPlacement !== "consentAndPaySection";

export const shouldShowConsentAndPaySubscriptionBillingDisclaimer = (
  subscriptionTermsPlacement: CheckoutConfigurationSubscriptionTermsPlacement | null | undefined,
  isDesktopView: boolean
): boolean => isDesktopView && subscriptionTermsPlacement === "consentAndPaySection";
